import {
  Component,
  Input,
  OnInit,
  signal,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FollowUp } from '@app/modules/follow-ups/follow-ups.types';
import { SetFollowUpNotesAction } from '@app/modules/follow-ups/store/follow-ups.actions';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-follow-up-set-notes',
  imports: [ReactiveFormsModule, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './follow-up-set-notes.component.html',
})
export class FollowUpSetNotesComponent implements OnInit {
  private store = inject(Store);
  private modalRef = inject(NgbActiveModal);

  notesFormControl = new FormControl<string>('');

  @Input() followUp: FollowUp;
  loading = signal(false);

  ngOnInit() {
    this.notesFormControl.setValue(this.followUp.notes);
  }

  close() {
    this.modalRef.close();
  }

  submit() {
    this.loading.set(true);
    this.store
      .dispatch(
        new SetFollowUpNotesAction(
          this.followUp.id,
          this.notesFormControl.value
        )
      )
      .subscribe(() => {
        this.loading.set(false);
        this.modalRef.close();
      });
  }
}
